module.exports = __webpack_public_path__ + "img/2-4.b8f60511.svg";